import { createSlice } from '@reduxjs/toolkit';

const TOKEN_KEY = 'token';
const USER_KEY = 'app_user';
const ROLES_KEY = 'app_roles';
const AUTH_KIND_KEY = 'app_auth_kind';

function safeGetLocalStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeParseJSON(raw) {
  try {
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

const initialToken = safeGetLocalStorage(TOKEN_KEY);
const initialUser = safeParseJSON(safeGetLocalStorage(USER_KEY));
const initialRoles = safeParseJSON(safeGetLocalStorage(ROLES_KEY)) || { isDoctor: false, isOps: false };
const initialAuthKind = safeGetLocalStorage(AUTH_KIND_KEY) || 'member';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: initialToken,
    user: initialUser,
    roles: initialRoles,
    authKind: initialAuthKind,
    status: 'idle',
  },
  reducers: {
    loginSuccess(state, action) {
      const { token, user, roles, authKind } = action.payload || {};
      state.token = token || null;
      state.user = user || null;
      state.roles = roles || { isDoctor: false, isOps: false };
      state.authKind = authKind || 'member';

      try {
        if (state.token) localStorage.setItem(TOKEN_KEY, state.token);
        else localStorage.removeItem(TOKEN_KEY);

        if (state.user) localStorage.setItem(USER_KEY, JSON.stringify(state.user));
        else localStorage.removeItem(USER_KEY);

        localStorage.setItem(ROLES_KEY, JSON.stringify(state.roles));
        localStorage.setItem(AUTH_KIND_KEY, state.authKind);
      } catch {
        // ignore storage write errors
      }
    },

    setRoles(state, action) {
      state.roles = action.payload || { isDoctor: false, isOps: false };
      try {
        localStorage.setItem(ROLES_KEY, JSON.stringify(state.roles));
      } catch {
        // ignore
      }
    },

    logout(state) {
      state.token = null;
      state.user = null;
      state.roles = { isDoctor: false, isOps: false };
      state.authKind = 'member';
      state.status = 'idle';

      try {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
        localStorage.removeItem(ROLES_KEY);
        localStorage.removeItem(AUTH_KIND_KEY);
        sessionStorage.removeItem('app_user');
        sessionStorage.removeItem('signup_email');
        sessionStorage.removeItem('auth_email');
      } catch {
        // ignore storage write errors
      }
    },
  },
});

export const { loginSuccess, setRoles, logout } = authSlice.actions;
export default authSlice.reducer;
